import { useCallback, useRef } from 'react';
import useDebouncedCallback from '@atlassian/jira-platform-use-debounce/src/utils/use-debounce-callback/index.tsx';
import { useIFCConfigContext } from '../context/index.tsx';

export const useIFCEditField = (fieldSetId: string) => {
	const { ifcConfig, optimisticUpdateField, replaceFieldSetInColumns } = useIFCConfigContext();

	const currentFieldSetId = useRef<string>(fieldSetId);

	const onStartFieldUpdate = useCallback(
		(
			id: string,
			field: {
				name: string;
				type: string;
				options?: { id: string; value: string }[] | undefined;
			},
		) => {
			optimisticUpdateField?.(id, field);
		},
		[optimisticUpdateField],
	);

	const [onFieldUpdated] = useDebouncedCallback(
		(
			fieldId: string,
			field?: {
				name: string;
				type: string;
				collapsedName?: string | undefined;
			},
		) => {
			if (field?.collapsedName && currentFieldSetId.current) {
				replaceFieldSetInColumns?.(currentFieldSetId.current, field.collapsedName, fieldId);
				currentFieldSetId.current = field?.collapsedName;
			}
		},
		500,
	);

	const onUpdate = (fieldId: string) => {
		ifcConfig?.onUpdate({
			fieldId,
			onStartFieldUpdate: (field) => onStartFieldUpdate(fieldId, field),
			onFieldUpdated,
		});
	};

	return onUpdate;
};
